<template>
<div>
 <el-breadcrumb separator-class="el-icon-arrow-right">
  <el-breadcrumb-item :to="{ path: '/text' }">首页</el-breadcrumb-item>
  <el-breadcrumb-item>新闻管理</el-breadcrumb-item>
  <el-breadcrumb-item>新闻列表</el-breadcrumb-item>
</el-breadcrumb>
<!-- 图片视图 -->
<el-card>
  
<!-- 搜索区域 -->
<el-row>
  <el-col :span="6">
  <div>
  <el-input placeholder="请输入新闻标题" v-model="input3" @keyup.enter.native="getNews" class="input-with-select">
    <el-button slot="append" icon="el-icon-search" @click="getNews"  ></el-button>  
  </el-input>
  
  <!-- <span>查询到{{newslist.length}}条数据</span> -->
</div>
</el-col>
 <el-col :span="3"> <p class="lableforSearch">查询到{{newslist.length}}条数据</p></el-col>
  <el-col :span="6">
  <el-button type="primary" @click="insertNews" v-if="userType==2">
添加新闻
  </el-button></el-col>
</el-row>
<!-- 新闻列表区域 -->
  <el-table
    :data="newslist"
     border
    style="width: 100%">
    <el-table-column
    label="序号"
     type="index"
     width="50"
     >
    </el-table-column>
       <el-table-column
      prop="newsTime"
      label="新闻时间"
      width="180">
    </el-table-column>
    <el-table-column
      prop="news_TITLE"
      label="新闻标题"
      width="180">
    </el-table-column>
    <el-table-column
      prop="news_CONTENT"
      :show-overflow-tooltip="true"
      label="新闻描述"
      width="180">
    </el-table-column>
        <el-table-column
      prop="newsFilePath"
      :show-overflow-tooltip="true"
      label="html状态"
      width="180">
    </el-table-column>
    <el-table-column
      label="是否显示" 
      width="120">
      <!-- 卡槽 -->
      <template slot-scope="scope">
<el-switch
  v-model="scope.row.news_AllShow" @change="newAllShow(scope.row)">
</el-switch>
</template>
    </el-table-column>
    <el-table-column
      label="是否首页显示" 
      width="120">
      <!-- 卡槽 -->
      <template slot-scope="scope">
<el-switch
  v-model="scope.row.news_show" @change="newShow(scope.row)">
</el-switch>
</template>
    </el-table-column>

    <el-table-column
      prop="checkNews"
      :show-overflow-tooltip="true"
      :formatter="stateFormat"
      label="是否通过审核"
      width="120">
    </el-table-column>
    <el-table-column
      prop="username"
      :show-overflow-tooltip="true"
      label="审核账户"
      width="120">
    </el-table-column>
    <el-table-column
      prop="message"
      :show-overflow-tooltip="true"
      label="留言"
      width="120">
    </el-table-column>
    <el-table-column
      label="操作"
      width="280"
      >
      <template slot-scope="scope">
<el-button v-if="userType==2 & scope.row.checkNews!=true"  size="small" @click="inserHtml(scope.row)"  ><svg class="icon" aria-hidden="true"><use xlink:href="#icon-tianjia"></use></svg></el-button>
<el-button v-if="userType==2  & scope.row.checkNews!=true"  size="small" @click="updateNew(scope.row)"  ><svg class="icon" aria-hidden="true"><use xlink:href="#icon-xiugai"></use></svg></el-button>
<el-button v-if="userType==2"  size="small" @click="deleteNews(scope.row)"><svg class="icon" aria-hidden="true"><use xlink:href="#icon-shanchu"></use></svg></el-button>
<el-button   size="small" @click="showNews(scope.row)"><svg class="icon" aria-hidden="true">
  <use xlink:href="#icon-chakan2"></use>
</svg></el-button>
<el-button v-if="userType==4  & scope.row.checkNews!=true"  size="small" @click="getconfirm(scope.row)"  ><svg class="icon" aria-hidden="true">
  <use xlink:href="#icon-dui"></use>
</svg></el-button>
      </template>
    </el-table-column>
  </el-table>
</el-card>
<!-- 弹窗 -->
<el-dialog
  title="新闻添加"
  :visible.sync="insertNew"
  width="50%"
  >
  <!-- 主体区域 -->
  <el-form ref="addNewsRef" :model="addForm" :rules="addNewsRules" label-width="80px">
  <el-form-item label="新闻标题" prop="NEWS_TITLE">
    <el-input v-model="addForm.NEWS_TITLE"></el-input>
  </el-form-item>
  <el-form-item label="新闻内容" prop="NEWS_CONTENT">
    <el-input type="textarea" v-model="addForm.NEWS_CONTENT"></el-input>
  </el-form-item>
  <el-form-item label="新闻类型" prop="new_type">
    <el-select   v-model="addForm.new_type" id="selectNew" >
    <el-option label="动态" value="动态"></el-option>
     <el-option label="快讯" value="快讯"></el-option>
      <el-option label="深度" value="深度"></el-option>
    </el-select>
  </el-form-item>
  <el-form-item label="汇报时间">
    <el-date-picker
      v-model="addForm.newsTime"
      type="datetime"
      placeholder="选择日期时间"
      align="right"
       :picker-options="pickerOptions"
      value-format="yyyy-MM-dd HH:mm:ss"
      default-time	
      >
    </el-date-picker>
  </el-form-item>

  <el-form-item label="新闻图片" prop="imageUrl">
 <el-upload action="uploadAction" list-type="picture-card"
                                       :on-preview="handlePictureCardPreview"
                                       :on-remove="handleRemove"
                                       :limit="1"
                                       :show-file-list="true"
                                       name="img"
                                       ref="upload"
                                       :data="addForm"
                                       accept="image/png,image/gif,image/jpg,image/jpeg"
                                       :on-exceed="handleExceed"
                                       :auto-upload="false"
                                       :on-error="uploadError"
                                       :before-upload="handleBeforeUpload"
                                       :on-change="changeFile">
                                <i class="el-icon-plus"></i>
                            </el-upload>

</el-form-item>
  <el-form-item>
  </el-form-item>
</el-form>


  <!-- 底部区域 -->
  <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="onInsertSubmit">立即添加</el-button>
    <el-button @click="insertNew = false">取 消</el-button>
    <el-button  type="" @click="reset()">重置</el-button>
  </span>
</el-dialog>


<el-dialog
  title="新闻内容添加"
  :visible.sync="showInsertHtml"
  width="50%">


<el-row>
  <el-col :span="12"><div class="grid-content bg-purple">
<el-upload
  class="upload-demo"
  drag
  action="https://jsonplaceholder.typicode.com/posts/"
  :auto-upload="false"
  :on-change="fileChange"
   ref="uploads"
  :on-remove="fileRemove"
  accept=".html,.htm">
  <i class="el-icon-upload"></i>
  <div class="el-upload__text">将html文件拖到此处，或<em>点击上传</em></div>
</el-upload>
  </div></el-col>
  <el-col :span="12"><div class="grid-content bg-purple-light">

<el-upload
  class="upload-demo"
  drag
  ref="upload"
  action="https://jsonplaceholder.typicode.com/posts/"
  :auto-upload="false"
  multiple="multiple"
  :show-file-list="false"
  :on-change="handleChanges"
  :on-remove="handleRemoves">
  <i class="el-icon-upload"></i>
  <div class="el-upload__text">将文件样式文件拖到此处，或<em>点击上传</em></div>
   <div class="el-upload__tip" slot="tip">累计上传{{fileList5.length}}个文件</div>
</el-upload>
  </div></el-col>
</el-row>
















<div class="block">


</div>

  <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="resetResult">重 置</el-button>
    <el-button @click="showInsertHtml = false">取 消</el-button>
    <el-button type="primary" @click="subInsertHtml">提 交</el-button>
  </span>
</el-dialog>

<el-dialog
  title="新闻预览"
  :visible.sync="vieNews"
  width="100%"
  >
  <el-dialog
      width="30%"
      :visible.sync="innerVisible"
      append-to-body>

      <el-form   label-width="80px">
  <el-form-item label="留言:" prop="message">
    <el-input type="textarea" v-model="message"></el-input>
  </el-form-item>
  </el-form>
  <el-button type="primary" @click="updateNewCheck('haha')" v-if="userType==4 & newss.checkNews==null">确定</el-button>
  <el-button type="primary" @click="innerVisible=false">取消</el-button>
    </el-dialog>
<ShowNews  :newss="newss" :userType="userType" ></ShowNews>
<el-button type="primary" @click="updateNewCheck(true)" v-if="userType==4 & newss.checkNews==null">审核通过</el-button>
<el-button type="primary" @click="updateNewCheck(false)" v-if="userType==4 & newss.checkNews==null">审核不通过</el-button>
<el-button type="primary" @click="vieNews=false">取消</el-button>
</el-dialog>


<el-dialog
  title="新闻修改"
  :visible.sync="updateNews"
  width="50%"
  @close="updateClose"
  >
  <!-- 主体区域 -->
  <el-form ref="addNewsRef" :model="addForm" :rules="addNewsRules" label-width="80px">
  <el-form-item label="新闻标题" prop="NEWS_TITLEs">
    <el-input v-model="addForm.NEWS_TITLEs" ></el-input>
  </el-form-item>
  <el-form-item label="新闻内容" prop="NEWS_CONTENTs">
    <el-input type="textarea" v-model="addForm.NEWS_CONTENTs"></el-input>
  </el-form-item>
   <el-form-item label="新闻类型" prop="new_type">
    <el-select   v-model="addForm.new_type" id="selectNew">
    <!-- <el-option   label="动态" :value='addForm.new_type'>{{addForm.new_type}}</el-option> -->
     <el-option   label="动态" value="动态"></el-option>
     <el-option  label="快讯" value="快讯"></el-option>
      <el-option label="深度" value="深度"></el-option>
    </el-select>
  </el-form-item>
  <el-form-item label="新闻图片" prop="imageUrl">
    <img :src="imgName" alt="加载失败" id="imgName"  v-show="showimage">
 <el-upload action="uploadAction" list-type="picture-card"
                                       :on-preview="handlePictureCardPreview"
                                       :on-remove="handleRemove2"
                                       :limit="1"
                                       :show-file-list="true"
                                       name="img"
                                       ref="upload"
                                       :data="addForm"
                                       accept="image/png,image/gif,image/jpg,image/jpeg"
                                       :on-exceed="handleExceed"
                                       :auto-upload="false"
                                       :file-list="fileList2"
                                       :before-upload="handleBeforeUpload"
                    
                                       :on-change="changeFile2"
                                       v-show="true">
                                <i class="el-icon-plus"></i>
                                
                            </el-upload>
</el-form-item>
  <el-form-item>
    <el-button type="primary" @click="onUpdateSubmit">立即修改</el-button>
  </el-form-item>
</el-form>


  <!-- 底部区域 -->
  <span slot="footer" class="dialog-footer">
     
    <el-button @click="updateNews = false">取 消</el-button>
  </span>
</el-dialog>
</div>
</template>

<script scoped>
    import ShowNews from '@/components/work/leader/ShowNews.vue'
export default {
  components:{ShowNews},
  data(){
    return{
      pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          }, {
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          }, {
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }]
        },
// {name: '', url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'}
     fileList:[],
     fileList2:[],
     fileList5: [],
     fileList6:[],
     fileList3:[],
     fileList4:[],
     userType:'',
      imagepath:'',
        input3: '',
        insertnewsid:'',
        formfile:{
         file:'',
         style:'',
        },
        showimage:true,
        newslist:[],
        imgName:'',
        news:{},
        insertNew:false,
        updateNews:false,
        showInsertHtml:false,
        innerVisible:false,
        vieNews:false,
        message:'',
        userType:'',
        check:true,
        newss:{},
        old_newsUrl:'',
        addForm:{
        newID:"",
        newsTime:'',
        value1: [new Date(2000, 10, 10, 10, 10), new Date(2000, 10, 11, 10, 10)],
        new_type:'',
        photo: '',
        imageUrl: '',
        NEWS_CONTENT:'',
        NEWS_TITLE:'',
        NEWS_TITLEs:'',
        NEWS_CONTENTs:'',
       },
        addNewsRules:{
          NEWS_TITLE:[
            {required:true,message:'请输入新闻标题',trigger:'blur'},
            {min:3,max:100,message:'新闻标题的长度在3~100个字符之间'}
            ],
          NEWS_CONTENT:[
             {required:true,message:'请输入新闻内容',trigger:'blur'},
            {min:3,max:10000,message:'新闻标题的长度在3~10000个字符之间'}
          ],
           NEWS_TITLEs:[
            {required:true,message:'请输入新闻标题',trigger:'blur'},
            {min:3,max:100,message:'新闻标题的长度在3~100个字符之间'}
            ],
          NEWS_CONTENTs:[
             {required:true,message:'请输入新闻内容',trigger:'blur'},
            {min:3,max:10000,message:'新闻标题的长度在3~10000个字符之间'}
          ],
           imageUrl:[
             {required:true,message:'请选择新闻图片',trigger:'blur'},          
          ],
        },
  }},
created(){  this.getNews()
},
methods:{
  getNews(){
    this.userType=JSON.parse(localStorage.getItem("user")).type
      this.addForm.newsTime =this.format(new Date(),'yyyy-MM-dd HH:mm:ss')
          this.axios.post("/news/getNews?NEWS_TITLE="+this.input3)
          .then(resp => { 
                      if(resp.data.status == 1) {    
                         this.imagepath=this.$imagepath                                                   
                                    this.infolist=resp.data.result;
                                    console.log(resp.data.result)   
                                    this.newslist=resp.data.result                                                                   
                                }else {
                                   alert("拿取数据失败")                                 
                                }
                            })
                            .catch((err) => {
                               // alert("出错了")
                                console.log(err)
                            }) 
      },        stateFormat(row, column) {
    if (row.checkNews === null) {
      return '未审核'
    } else if(row.checkNews==0){
      return '未通过'
    }else  {
      return '已通过'
    } 
  },
      newShow(datas){
        if(datas.checkNews==null||!datas.checkNews){
          this.$message.error("新闻还未通过审核")
          datas.news_show=false
          return
        }
        var numbers=0
        for (let index = 0; index < this.infolist.length; index++) {
          if(this.infolist[index].news_show){
            numbers=numbers+1
          }
        }
        if(numbers>3){
          this.$message.error("只能选择三个新闻作为首页显示")
          datas.news_show=false
          return
        }

        this.axios.post("/news/updateNewsShow","NEWSID="+datas.newsid+"&news_show="+datas.news_show)
          .then(resp => { 
                      if(resp.data.status == 1) {                                                                                        
                                    this.getNews()                    
                                }else {
                                   alert("拿取数据失败")                                 
                                }
                            })
                            .catch((err) => {
                                console.log(err)
                            }) 
      },newAllShow(data){
        if(data.checkNews==null||!data.checkNews){
          this.$message.error("新闻还未通过审核")
          data.news_AllShow=false
          return
        }
        this.axios.post("/news/updateNewsShow","NEWSID="+data.newsid+"&news_AllShow="+data.news_AllShow)
          .then(resp => { 
                      if(resp.data.status == 1) {                                                                                        
                                    console.log(resp.data.result)                      
                                    this.getNews()                    
                                }else {
                                   alert("拿取数据失败")                                 
                                }
                            })
                            .catch((err) => {
                               // alert("出错了")
                                console.log(err)
                            }) 
      },showNews(data){
       this.userType=JSON.parse(localStorage.getItem("user")).type
        this.vieNews=true
        console.log(data)
        this.newss=data
      },
      deleteNews(data){
        const that=this
        this.$confirm("确定删除？","提示",{
          confirmButtonText: "确认",//确认按钮文字更换
          cancelButtonText: "取消",//取消按钮文字更换
          showClose: true,//是否显示右上角关闭按钮
          type: "warning",//提示类型  success/info/warning/error
      }).then(function(){
        that.axios.post("/news/deleteNews","NEWSID="+data.newsid+"&NEWS_FILE_PATH="+data.news_FILE_PATH)
          .then(resp => { 
                      if(resp.data.status == 1) {    
                        that.$message.success("删除成功")  
                         that.getNews()                                                                                                                                         
                                }else {
                                   alert("拿取数据失败")                                 
                                }
                            })
                            .catch((err) => { alert("出错了")
                             console.log(err)
                            }) 

      }).catch(()=>{});
       },
      inserHtml(data){
        this.insertnewsid=data.newsid
          this.showInsertHtml=true;
      },
      insertNews(){
        this.insertNew=true
      }, updateNew(data){
              this.axios.post("/news/getNewsById","NEWSID="+data.newsid)
          .then(resp => {  
                      if(resp.data.status == 1) {              
                                     this.addForm.imageUrl=' '
                                    console.log(resp.data) 
                                    this.addForm.NEWS_TITLEs=resp.data.result.news_TITLE
                                     this.addForm.NEWS_CONTENTs=resp.data.result.news_CONTENT
                                     this.addForm.newID=resp.data.result.newsid  
                                     this.addForm.new_type=resp.data.result.new_type    
                                    console.log(this.fileList)
                                     this.imgName=this.imagepath+resp.data.result.news_FILE_PATH 
                                     this.old_newsUrl=resp.data.result.news_FILE_PATH                                                              
                                }else {
                                   alert("拿取数据失败")                                 
                                }
                            })
                            .catch((err) => {
                               
                               alert("出错了")
                                console.log(err)
                            }) 

        this.updateNews=true
      },updateClose(){
       
      },updateNewCheck(data){
        if(data==true||data==false){
          this.check=data
          data='falses'
        }
        if(data=="falses"){
          this.innerVisible=true
        }else{ 
      let fd = new FormData();
      let config = {headers: { "Content-Type": "application/json" }};    
      fd.append("message",this.message)
      fd.append('NEWSID', this.newss.newsid);
      fd.append('checkNews', this.check);
      fd.append('checkUserId', JSON.parse(localStorage.getItem("user")).userid);
        this.axios.post("/news/updateNewCheck",fd,config)
          .then(resp => { 
                      if(resp.data.status == 1) {     
                        this.$message.success("已审核")                                                                                  
                                this.message=''
                                this.vieNews=false
                                this.innerVisible=false
                                   this.getNews()                      
                                }else {
                                   alert("拿取数据失败")                                 
                                };
                            })
                            .catch((err) => {
                               // alert("出错了")
                                console.log(err)
                            }) 
        }
      },getconfirm(data){
        this.userType=JSON.parse(localStorage.getItem("user")).type
        this.newss=data

        const that=this
        this.$confirm("确定审核通过？","提示",{
        iconClass: "el-icon-question",//自定义图标样式
          confirmButtonText: "确认",//确认按钮文字更换
          cancelButtonText: "取消",//取消按钮文字更换
          showClose: true,//是否显示右上角关闭按钮
          type: "warning",//提示类型  success/info/warning/error
      }).then(function(){
          //确认操作
          that.check=true
          that.updateNewCheck('66')
      }).catch(()=>{
       
      });
      
      },
          onInsertSubmit() {
            this.$refs.addNewsRef.validate(valid=>{
              if(!valid) return 
    let config = {
        headers: { "Content-Type": "multipart/form-data" }
      };
      let fd = new FormData();
      

      let that = this;
      fd.append("NewsFile",that.addForm.imageUrl)
      fd.append('NEWS_TITLE', this.addForm.NEWS_TITLE);
      fd.append('NEWS_CONTENT', this.addForm.NEWS_CONTENT);
        this.axios.post("/news/insertNews",this.addForm,config)
          .then(resp => { 
                      if(resp.data.status == 1) {     
                        this.$message.success("添加成功")                                                                                  
                                    console.log(resp.data.result)     
                                    this.getNews()
                                   this.insertNew=false
                                   this.$refs.upload.clearFiles()
                                   this.$refs.addNewsRef.resetFields()
                                                         
                                }else {
                                   alert("拿取数据失败")                                 
                                };
                            })
                            .catch((err) => {
                               // alert("出错了")
                                console.log(err)
                            }) 
            })
        
      },     submitForms(){
             
         let config = {
        headers: { "Content-Type": "multipart/form-data" }
           };
    
     this.axios.post("/news/insertNewsHtml",this.formfile,config)

            } ,
      reset(){
        this.$refs.addNewsRef.resetFields()
      },resets(){
        this.$refs.addNewsRef.resetFields()
      }, handleChange(value) {
        console.log(value);
      },
      //文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用
            onChange(file, fileList) {
              alert("触发")
                console.log(file.raw);
                //console.log(this.$refs.userPhoto);
                this.userForm.imageUrl = URL.createObjectURL(file.raw);
                
            },
            
            // 上传文件之前的钩子
            handleBeforeUpload(file) {
              
                console.log('按钮', this.titleMap)
                if (!(file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type ===
                    'image/jpeg')) {
                    this.$notify.warning({
                        title: '警告',
                        message: '请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片'
                    })
                }
                let size = file.size / 1024 / 1024 / 2;
                if (size > 2) {
                    this.$notify.warning({
                        title: '警告',
                        message: '图片大小必须小于2M'
                    })
                }

            },
         subInsertHtml(){
         if(this.fileList5.length <= 0 ||this.fileList3.length==0 ){
           this.$message.error("请选择上传文件") 
         return false}



    for(var i=0;i<this.fileList5.length;i++){
     this.fileList6.push(this.fileList5[i].raw)
    }
    this.fileList4=this.fileList3[0].raw
     let config = {
        headers: { "Content-Type": "multipart/form-data" }
      };
      const fd = new FormData();
    // fd.append("style",this.fileLists)
     
       this.fileList6.forEach((file) => {
         fd.append("style", file);
      });
      fd.append("NEWSID",this.insertnewsid)
      fd.append("file",this.fileList4)
        this.axios.post("/news/insertNewsHtml",fd,config)
         .then(resp => { 
                       if(resp.data.status == 1) {
                                  this.$message.success("添加成功")
                                  this.fileList5=[]
                                  this.fileList6=[]
                                  this.fileList3=[]
                                  this.fileList4=[]
                                  this.$refs.upload.clearFiles()
                                  this.$refs.uploads.clearFiles()
                                   this.showInsertHtml=false
                                   
                                }else {
                                  this.$message.error(resp.data.message)                 
                                  this.fileList6=[]                                 
                                  this.fileList4=[]
                                       alert("出错")                          
                                }
                            })
                            .catch((err) => {
                                alert("出错了")
                                console.log(err)
                            }) 
  
      },
            //图片上传超过数量限制
            handleExceed(files, fileList) {
                this.$message.error("上传图片不能超过1张!");
            },
            handleRemove(file,fileList) {

              
              // const filepath=file.url
              // const d=this.fileList.findIndex(x=>x.url===filepath)
              // this.fileList.splice(d,1)
              // alert(d)
             // this.addForm.imageUrl=''
             
                this.$message.error("删除成功!");
                this.addForm.imageUrl=''
            },
                        handleRemove2(file,fileList) {
           
             this.showimage=true
                this.$message.error("删除成功!");
                this.addForm.imageUrl=''
            },
            // 图片上传失败时
            uploadError() {
                this.$message.error("图片上传失败!");
            },resetResult(){
         this.fileList5=[]
                                  this.fileList6=[]
                                  this.fileList3=[]
                                  this.fileList4=[]
                                  this.$refs.upload.clearFiles()
                                  this.$refs.uploads.clearFiles()
      },
            //预览图片
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            //文件改变时 on-change方法 ，fileList[0].raw 就是传给后端的值
            //filelist这个对象里面有很多属性，我们上传文件时，实际上传的是filelist列表中每一项的raw,只有raw可以正常上传， 获取到文件后，需要定义变量保存文件。所以需要获取filelist中的raw进行保存。
            //这里我用的formdata上传多文件，console打印formdata，文件在控制台中显示的格式为binary。

            changeFile(file, fileList) {
              this.showimage=false
                this.addForm.imageUrl = fileList[0].raw
     
            },
                 changeFile2(file, fileList) {
              this.showimage=false
                this.addForm.imageUrl = fileList[0].raw
     
            },handleChanges(file, fileList) {
      this.fileList5=fileList
      },handleRemoves(file, fileList) {
        this.fileList5=fileList
      },fileChange(file, fileList){
        this.fileList3=fileList
      },fileRemove(file, fileList){
        this.fileList3=fileList
      },         format(time, format) {
                var t = new Date(time);
                var tf = function (i) { return (i < 10 ? '0' : '') + i };
                return format.replace(/yyyy|MM|dd|HH|mm|ss/g, function (a) {
                    switch (a) {
                        case 'yyyy':
                            return tf(t.getFullYear());
                            break;
                        case 'MM':
                            return tf(t.getMonth() + 1);
                            break;
                        case 'mm':
                            return tf(t.getMinutes());
                            break;
                        case 'dd':
                            return tf(t.getDate());
                            break;
                        case 'HH':
                            return tf(t.getHours());
                            break;
                        case 'ss':
                            return tf(t.getSeconds());
                            break;
                    }
                })
            }, 
      viewnew(){
              this.$refs['upload'].$children[0].$refs.click()
            },
            onUpdateSubmit(){
            this.$refs.addNewsRef.validate(valid=>{
              if(!valid) 
              retrun 
    let config = {
        headers: { "Content-Type": "multipart/form-data" }
      };
      let fd = new FormData();
      let that = this;
      fd.append("NewsFile",that.addForm.imageUrl)
      fd.append("oldNewsUrl",that.old_newsUrl)
      fd.append('NEWS_TITLE', this.addForm.NEWS_TITLEs);
      fd.append('NEWS_CONTENT', this.addForm.NEWS_CONTENTs);
      fd.append('NEWSID', this.addForm.newID);
      fd.append('new_type', this.addForm.new_type);
        this.axios.post("/news/updateNews",fd,config)
          .then(resp => { 
                      if(resp.data.status == 1) {                                                                                        
                                    console.log(resp.data.result)     
                                    location. reload()                                 
                                }else {
                                   alert("拿取数据失败")                                 
                                }
                            })
                            .catch((err) => {
                               // alert("出错了")
                                console.log(err)
                            })          })

            }} ,    
           
  }
</script>

<style scoped>
.el-main{
  line-height: 0 !important;
 
}

  .el-card{
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.15) !important;
  }
#imgName{
  float: left;
 width: 138px;
 height:138px ;
padding-left: 80px;
}
.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
 .lableforSearch{
      margin-top:8px;
      color:grey
}
</style>


// WEBPACK FOOTER //
// src/components/work/getnews.vue